const initialState = {
    isReadingContacts: false,
    contacts: [],
    count: 0,
    contactBeingUpdated: null,
    isReadingTextCampaignContacts: false,
    textCampaignContacts: [],
    textCampaignContactsCount: 0
}

export default initialState;
